import $ from 'jquery';
import 'slick-carousel';

var $slider = $('.tile-slider__slides');

$slider.each(function () {
    let $slide = $(this);

    $slide.slick({
        infinite: false,
        arrows: true,
        dots: false,
        draggable: false,
        variableWidth: true,
        prevArrow: '<a href="#" aria-label="Vorheriger Slide" class="slick-prev fa-thin fa-chevron-left"></a>',
        nextArrow: '<a href="#" aria-label="Nächster Slide" class="slick-next fa-thin fa-chevron-right"></a>',
        appendArrows: $('<div>').addClass('tile-slider__arrows').insertAfter($slide),
        responsive: [{
            breakpoint: 768,
            settings: {
                draggable: true,
                variableWidth: false,
                slidesToShow: 1,
            }
        }]
    });
})

$(window).on('resize', function () {
    $slider.each(function () {
        let sliderWidth = 0;

        $(this).find('.tile-slider__slide').each(function () {
            sliderWidth += $(this).outerWidth();
        });

        if(sliderWidth < $(this).width()) {
            $(this).siblings('.tile-slider__arrows').addClass('tile-slider__arrows--small');
        } else {
            $(this).siblings('.tile-slider__arrows').removeClass('tile-slider__arrows--small');
        }
    });

});


